/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import { AgGridReact } from 'ag-grid-react';
import { AllModules } from 'ag-grid-enterprise';
import Axios from 'axios'
import APP_CONSTANTS from '../../../config/constants'
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'ag-grid-enterprise';
import AgGridTable from '../../agGridComponent/agGridTable';
import TyreInventoryActionButton from './tyreInventoryAction'
import { FEATURES } from '../../../utils/constants';

function UserTable(props) {
  const [users, setusers] = useState([])
  const [isLoading, setisLoading] = useState(true)
  const [isUpdated, setisUpdated] = useState(false)
  useEffect(() => {
    getData()
  }, [isUpdated])
  let getUpdate = (data) => {
    if (data) {
      setisUpdated(!isUpdated)
    }
  }

  let getData = () => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/tyre/?customerNumber=${customerNo}&userId=${userId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      setusers(response.data.resultSet)
      setisLoading(false)
    }))
      .catch(error => console.log(error))
  }


  // if (users?.length === 0 && isLoaded === false) {
  //   return (
  //     <LoadingPlaceholder />
  //   )
  // } else if (users?.length === 0) {
  //   return (
  //     <Segment className="m-2">
  //       <center> <Header>NO Record(s) Found</Header></center>
  //     </Segment>
  //   )
  // } else {

    let columnDefs = [
      /* { headerName: 'Employee Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true }, */
      { headerName: 'Tyre Code', field: 'tyreCode', tooltipField: 'tyreCode', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Serial No', field: 'serialNo', tooltipField: 'serialNo', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Tyre Position', field: 'tyrePosition', tooltipField: 'tyrePosition', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Tyre Size', field: 'tyreSize', tooltipField: 'tyreSize', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Tyre Type', field: 'tyreType', tooltipField: 'tyreType', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: 'Tyre Make', field: 'tyreMake', tooltipField: 'tyreMake', enableRowGroup: true, enablePivot: true },
      { headerName: 'Tyre Status', field: 'tyreStatus', tooltipField: 'tyreStatus', enableRowGroup: true, enablePivot: true },
      { headerName: 'Tyre Model', field: 'tyreModel', tooltipField: 'tyreModel', enableRowGroup: true, enablePivot: true },
      { headerName: 'Tyre Thread', field: 'threadDepth', tooltipField: 'threadDepth', enableRowGroup: true, enablePivot: true },
      { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
    ]
    let rowData = [];

    (users != null || users != undefined) && users.map((object, i) => {
      let temp = {}
      temp.tyreCode = object.tyreCode ? object.tyreCode : ''
      temp.serialNo = object.serialNo
      temp.tyreSize = object.tyreSize
      temp.tyreSizeId = object.tyreSizeId
      temp.tyreType = object.tyreType
      temp.tyreTypeId = object.tyreTypeId
      temp.tyreMake = object.tyreMake
      temp.tyreMakeId = object.tyreMakeId
      temp.tyreStatus = object.tyreStatus
      temp.tyreStatusId = object.tyreStatusId
      temp.tyrePosition = object.tyrePosition
      temp.tyrePositionId = object.tyrePositionId
      temp.threadDepth = object.threadDepth
      temp.tyreModel = object.tyreModel
      temp.tyreModelId = object.tyreModelId
      temp.tyreId = object.tyreId
      rowData[i] = temp
    })
    return (
      <React.Fragment >
        <AgGridTable
          columnDefs={columnDefs}
          actionButton={TyreInventoryActionButton}
          rowData={rowData}
          isLoading={isLoading}
          searchValue={props.searchValue}
          reload={getUpdate}
          link="#"
          hiddenNew={true}
          newPopup={props.newPopup}
          titleBarTitle="Tyre Inventory"
          handleSearch={props.handleSearch}
          hiddenImportPopupBtn={true}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    )
  }

//}

export default UserTable
